export const PRIORITY_LEVELS = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
  };
  
  export const PRIORITY_CONFIG = {
    [PRIORITY_LEVELS.HIGH]: {
      color: 'border-red-500 bg-red-50',
      badgeColor: 'bg-red-100 text-red-800',
      textColor: 'text-red-600',
      icon: 'AlertCircle'
    },
    [PRIORITY_LEVELS.MEDIUM]: {
      color: 'border-yellow-500 bg-yellow-50',
      badgeColor: 'bg-yellow-100 text-yellow-800',
      textColor: 'text-yellow-600',
      icon: 'Target'
    },
    [PRIORITY_LEVELS.LOW]: {
      color: 'border-green-500 bg-green-50',
      badgeColor: 'bg-green-100 text-green-800',
      textColor: 'text-green-600',
      icon: 'CheckCircle'
    }
  };
  
  export const ROUTES = {
    LOGIN: '/login',
    HOME: '/',
    PRIORITIES: '/priorities',
    OPENAI_TEST: '/test-openai'
  };
  
  export const ERROR_MESSAGES = {
    CREATE_TASK_FAILED: 'Failed to create task',
    UPDATE_TASK_FAILED: 'Failed to update task',
    DELETE_TASK_FAILED: 'Failed to delete task',
    LOGOUT_FAILED: 'Logout failed'
  };
  